module.exports = __webpack_public_path__ + "img/vue2-renfort_vert.33b539bc.png";